/// <reference path="../_references.ts"/>

module App.Payment {
	export class PaymentService {
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants
		) {

		}

		fetchPaymentInfo(serviceRequestId: number): ng.IHttpPromise<PaymentInfo> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/paymentinfo`);
		}

		fetchPayments(serviceRequestId: number): ng.IHttpPromise<Payment[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/payment`);
		}

		createPayment(serviceRequestId: number, payment: Payment): ng.IHttpPromise<Payment> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/payment`, payment);
		}

		fetchPaymentTypes(): ng.IHttpPromise<PaymentType[]> {
			return this.$http.get(`${this.Constants.apiUrl}paymenttype`);
		}

		sendPaymentEmail(serviceRequestId: number, paymentId: number, data: {email: string, note?: string}): ng.IHttpPromise<Payment> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/payment/${paymentId}/email`, data)
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new PaymentService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}